<div class="left-navigation">
  <button *ngIf="!isLocked" type="button" class="back-btn" (click)="goBack()">
    <span class="material-icons" aria-hidden="true">arrow_back_ios</span>
    Back
  </button>
  <hr />
  <div class="my-account">My Account</div>
  <div class="left-nav" [routerLink]="'/manageaccount'">
    <span class="material-icons">person</span>
    <a class="left-links">My Profile</a>
  </div>
  <div class="left-nav" [routerLink]="'/settings'">
    <span class="material-icons">settings</span>
    <a class="left-links">Account Settings</a>
  </div>
  <hr />
  <div
    class="left-nav"
    [routerLink]="'/contact'"
    routerLinkActive="router-link-active"
  >
    <span class="material-icons">info</span>
    <a class="left-links">Contact Us</a>
  </div>
  <div class="left-nav">
    <span class="material-icons">logout</span>
    <a (click)="logout()" class="left-links">Logout</a>
  </div>
</div>
